import { createBrowserRouter, Navigate } from 'react-router-dom';
import { LoginPage } from './features/auth/LoginPage';
import { ProtectedRoute } from './routes/ProtectedRoute';
import { DashboardPage } from './features/dashboard/DashboardPage';
import { CalendarPage } from './features/events/CalendarPage';
import { LeadsListPage } from './features/leads/LeadsListPage';
import { LeadDetailPage } from './features/leads/LeadDetailPage';
import { ClientsListPage } from './features/clients/ClientsListPage';
import { ClientDetailPage } from './features/clients/ClientDetailPage';
import { ContactsListPage } from './features/contacts/ContactsListPage';
import { ContactDetailPage } from './features/contacts/ContactDetailPage';
import { FollowupsPage } from './features/followups/FollowupsPage';
import { LeadStatusesPage } from './features/settings/LeadStatusesPage';
import { LeadCategoriesPage } from './features/settings/LeadCategoriesPage';
import { ContactCategoriesPage } from './features/settings/ContactCategoriesPage';
import { SourcesPage } from './features/settings/SourcesPage';
import { BirthdayTemplatesPage } from './features/settings/BirthdayTemplatesPage';
import { RolesPage } from './features/hrm/RolesPage';
import { DepartmentsPage } from './features/hrm/DepartmentsPage';
import { ShiftsPage } from './features/hrm/ShiftsPage';
import { StaffPage } from './features/staff/StaffPage';

export const router = createBrowserRouter([
  { path: '/login', element: <LoginPage /> },
  {
    element: <ProtectedRoute />,
    children: [
      { path: '/', element: <Navigate to="/dashboard" replace /> },

      { path: '/dashboard', element: <DashboardPage /> },
      { path: '/calendar', element: <CalendarPage /> },

      // CRM core (Run 3)
      { path: '/leads', element: <LeadsListPage /> },
      { path: '/leads/:id', element: <LeadDetailPage /> },
      { path: '/clients', element: <ClientsListPage /> },
      { path: '/clients/:id', element: <ClientDetailPage /> },
      { path: '/contacts', element: <ContactsListPage /> },
      { path: '/contacts/:id', element: <ContactDetailPage /> },
      { path: '/followups', element: <FollowupsPage /> },

      // Staff (users admin)
      { path: '/staff', element: <StaffPage /> },

      // HRM
      { path: '/hrm', element: <Navigate to="/hrm/roles" replace /> },
      { path: '/hrm/roles', element: <RolesPage /> },
      { path: '/hrm/departments', element: <DepartmentsPage /> },
      { path: '/hrm/shifts', element: <ShiftsPage /> },

      // Settings
      { path: '/settings', element: <Navigate to="/settings/lead-statuses" replace /> },
      { path: '/settings/lead-statuses', element: <LeadStatusesPage /> },
      { path: '/settings/lead-categories', element: <LeadCategoriesPage /> },
      { path: '/settings/contact-categories', element: <ContactCategoriesPage /> },
      { path: '/settings/sources', element: <SourcesPage /> },
      { path: '/settings/birthday-templates', element: <BirthdayTemplatesPage /> },

      // Legacy /lead-statuses path from Run 1 — redirect.
      { path: '/lead-statuses', element: <Navigate to="/settings/lead-statuses" replace /> },
    ],
  },
  { path: '*', element: <Navigate to="/" replace /> },
]);
